var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 0.707107,
    width: 32.9411,
    height: 32.9411,
    rx: 3.5,
    transform: "rotate(45 24 0.707107)",
    fill: "currentColor",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7439 27.3335L21.8799 18.8535V12.4535H26.8399V18.8535L26.0079 27.3335H22.7439ZM26.2959 34.4695C25.7626 35.0028 25.1226 35.2695 24.3759 35.2695C23.6292 35.2695 22.9892 35.0028 22.4559 34.4695C21.9226 33.9362 21.6559 33.2962 21.6559 32.5495C21.6559 31.8028 21.9226 31.1628 22.4559 30.6295C22.9892 30.0962 23.6292 29.8295 24.3759 29.8295C25.1226 29.8295 25.7626 30.0962 26.2959 30.6295C26.8292 31.1628 27.0959 31.8028 27.0959 32.5495C27.0959 33.2962 26.8292 33.9362 26.2959 34.4695Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e00600166374130ab9ca400dab97f1ba.svg";
export { ForwardRef as ReactComponent };